import { paperClasses, Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

export default function MuiPopover(theme: Theme): Components['MuiPopover'] {
  return {
    defaultProps: {
      elevation: 15,
    },
    variants: [
      {
        props: { shape: SHAPE_SQUARE },
        style: {
          [`& .${paperClasses.root}`]: {
            borderRadius: 0,
          },
        },
      },
      {
        props: { shape: SHAPE_CIRCULAR },
        style: {
          [`& .${paperClasses.root}`]: {
            borderRadius: theme.shape.borderRadiusCircular,
          },
        },
      },
    ],
    styleOverrides: {
      root: {
        marginTop: theme.spacing(0),
      },
    },
  };
}
